import React from 'react';
import {Link} from 'react-router-dom'

const PaymentsMethods = () => {
  return (
    <section id="payments-methods" className="py-16 bg-gradient-to-br from-blue-600 to-green-600">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            PAYFLEX PAYMENT SOLUTIONS
          </h2>
          <p className="text-blue-100 text-lg max-w-3xl mx-auto">
            Secure, Seamless & Smart Payment Solutions
          </p>
        </div>

        {/* Payments Card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300">
            <div className="relative">
              <img 
                src="/assets/Payments.png" 
                alt="PayFlex Payment Solutions" 
                className="w-full h-64 object-cover"
              />
              <div className="absolute top-4 left-4 bg-gradient-to-r from-blue-500 to-yellow-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                <span className="animate-pulse mr-2">💳</span> PAYMENT TECHNOLOGY
              </div>
            </div>
            
            <div className="p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-3">
                Power your business with PayFlex
              </h3>
              <p className="text-blue-600 font-semibold mb-4 text-lg">
                The ultimate payment gateway for businesses across Africa
              </p>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                Whether you're collecting payments, disbursing funds, or managing transactions, <strong>PayFlex</strong> offers a suite of flexible, secure, and hassle-free payment methods tailored to your needs. Designed specifically for African businesses with multi-currency support and local payment method integration.
              </p>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Why Choose PayFlex?</h4>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <span className="text-blue-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Multi-Channel Payments</strong> - Accept M-PESA, bank transfers, cards, and mobile wallets in one platform.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-blue-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Instant Payouts</strong> - Send money to suppliers, employees, or customers with just a few clicks.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-blue-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Bulk Payments</strong> - Process hundreds of transactions at once, saving time and reducing errors.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-blue-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Real-Time Notifications</strong> - Get instant SMS/email alerts for all transactions.</span>
                  </div>
                  <div className="flex items-start">
                    <span className="text-blue-500 mr-2 text-lg">✔</span>
                    <span className="text-gray-700"><strong>Robust Security</strong> - PCI-DSS compliant with encryption and fraud detection.</span>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Perfect For:</h4>
                <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-lg p-4 border border-blue-100">
                  <div className="grid md:grid-cols-2 gap-3 text-gray-700">
                    <div className="flex items-start">
                      <span className="text-green-600 mr-2">•</span>
                      <span>E-Commerce Businesses <em>(Seamless checkout experience)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-green-600 mr-2">•</span>
                      <span>SMEs & Corporates <em>(Payroll and vendor payments)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-green-600 mr-2">•</span>
                      <span>Freelancers & Gig Workers <em>(Request and receive payments)</em></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h4 className="font-bold text-gray-800 mb-3">Key Features:</h4>
                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="grid md:grid-cols-2 gap-3 text-gray-700">
                    <div className="flex items-start">
                      <span className="text-yellow-500 mr-2">•</span>
                      <span>Customizable Payment Links <em>(Share via SMS, email, or social media)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-yellow-500 mr-2">•</span>
                      <span>Automated Reconciliation <em>(Match transactions with invoices)</em></span>
                    </div>
                    <div className="flex items-start">
                      <span className="text-yellow-500 mr-2">•</span>
                      <span>Detailed Reporting <em>(Track payments, refunds, and disputes)</em></span>
                    </div>
                  </div>
                </div>
              </div>

              <p className="text-blue-600 font-semibold mb-6 text-center text-lg flex justify-center items-center">
                <span className="mr-2">Switch to PayFlex and experience payments made easy!</span>
                <span className="text-2xl">💳</span>
              </p>

              <Link
                to="/contact"  // Make sure this matches your registration route
                className="inline-flex items-center justify-center w-full bg-gradient-to-r from-blue-600 to-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
              >
                <span>Streamline Your Transactions Now</span>
                <svg 
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-4xl mx-auto border border-white/20">
            <h3 className="text-2xl font-bold text-white mb-4">
              Ready to Transform Your Payment Processing?
            </h3>
            <p className="text-blue-100 mb-6 text-lg">
              Join businesses across Africa that are simplifying transactions with PayFlex
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
                          <Link
                            to="/contact"
                            className="inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-green-700 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                          >
                            Sign Up Today
                          </Link>
                          <Link
                            to="/contact"
                            className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                          >
                            Contact Our Team
                          </Link>
                        </div>
            <p className="text-yellow-200 mt-6 text-sm">
              Powered by Infinity Tech Africa - Your Trusted Payment Partner.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentsMethods;